import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  const navItems = [
    { name: 'Home', hash: 'home' },
    { name: 'About', hash: 'about' },
    { name: 'Qualification', hash: 'qualification' },
    { name: 'Projects', hash: 'projects' },
    { name: 'Contact', hash: 'contact' }
  ];

  // Check if mobile view
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setIsOpen(false);
      }
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.nav-container')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 py-4">
      <div className="container mx-auto px-4">
        {/* Desktop Navigation */}
        <div className="hidden md:flex justify-center">
          <ul className="flex space-x-2 md:space-x-4 lg:space-x-6 px-4 md:px-6 py-2 rounded-full  backdrop-blur-md  bg-white/10 hover:bg-white/20 transition-all duration-300">
            {navItems.map((item) => (
              <li key={item.hash}>
                <Link
                  to={item.hash}
                  smooth={true}
                  duration={500}
                  offset={-80}
                  spy={true}
                  onSetActive={() => setActiveSection(item.hash)}
                  className={`relative group px-3 py-2 font-medium ${
                    activeSection === item.hash ? 'text-white' : 'text-gray-300'
                  } hover:text-white transition-colors duration-300 cursor-pointer text-sm md:text-base`}
                >
                  {item.name}

                  {/* Active/hover indicator */}
                  <span
                    className={`absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-blue-400 to-cyan-400 transition-all duration-300 ${
                      activeSection === item.hash ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                    }`}
                  ></span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Mobile Navigation */}
        <div className="md:hidden flex justify-between items-center nav-container">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            aria-label="Toggle menu"
          >
            <div className="w-6 space-y-1.5">
              <span
                className={`block h-0.5 bg-white transition-all duration-300 ${
                  isOpen ? 'rotate-45 translate-y-2' : ''
                }`}
              ></span>
              <span
                className={`block h-0.5 bg-white transition-all duration-300 ${
                  isOpen ? 'opacity-0' : 'opacity-100'
                }`}
              ></span>
              <span
                className={`block h-0.5 bg-white transition-all duration-300 ${
                  isOpen ? '-rotate-45 -translate-y-2' : ''
                }`}
              ></span>
            </div>
          </button>

          {/* Mobile Menu */}
          <div
            className={`absolute top-full left-0 right-0 bg-gray-900/95 backdrop-blur-lg border-t border-gray-800 transition-all duration-300 overflow-hidden ${
              isOpen ? 'max-h-screen py-4' : 'max-h-0 py-0'
            }`}
          >
            <ul className="flex flex-col space-y-3 px-4">
              {navItems.map((item) => (
                <li key={item.hash}>
                  <Link
                    to={item.hash}
                    smooth={true}
                    duration={500}
                    offset={-80}
                    spy={true}
                    onSetActive={() => {
                      setActiveSection(item.hash);
                      setIsOpen(false);
                    }}
                    className={`block px-4 py-3 rounded-lg font-medium ${
                      activeSection === item.hash
                        ? 'bg-blue-900/30 text-white'
                        : 'text-gray-300 hover:bg-gray-800/50'
                    } transition-colors duration-300 cursor-pointer`}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;